import React from "react";
import { CustomSchemaField } from "../../../interfaces/doc";
import { getFieldPath } from "../../Common/SchemaUtils";
import { getField } from "./ResultFormUtils";

const getCustomFormField = (custom_schema: CustomSchemaField[]) => {
  const CustomFormFields: React.FC<{
    extractionId: string;
    extractionPath?: string;
    label?: string;
  }> = ({ extractionId, extractionPath }) => {
    return (
      <div className="flex flex-col gap-3 flex-1">
        {custom_schema.map(({ name, parsing_type, enum_values }) => {
          const FormField = getField(parsing_type, null, enum_values);
          return (
            <FormField
              key={getFieldPath([extractionPath, name])}
              extractionId={extractionId}
              extractionPath={getFieldPath([extractionPath, name])}
              label={name}
            />
          );
        })}
      </div>
    );
  };
  return CustomFormFields;
};
export default getCustomFormField;
